'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _progress = require('./progress');

var _progress2 = _interopRequireDefault(_progress);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // @ts-nocheck


var CrossIcon = function () {
  function CrossIcon(props) {
    return _react2['default'].createElement(
      'svg',
      props,
      _react2['default'].createElement('path', {
        d: 'M15 5L5 15M5 5l10 10',
        stroke: '#A8A4B9',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      })
    );
  }

  return CrossIcon;
}();

CrossIcon.defaultProps = {
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
};

var PauseIcon = function () {
  function PauseIcon(props) {
    return _react2['default'].createElement(
      'svg',
      props,
      _react2['default'].createElement('path', {
        d: 'M8.333 3.333H5v13.334h3.333V3.333zM15 3.333h-3.333v13.334H15V3.333z',
        stroke: '#A8A4B9',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      })
    );
  }

  return PauseIcon;
}();

PauseIcon.defaultProps = {
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
};

var DownloadIcon = function () {
  function DownloadIcon(props) {
    return _react2['default'].createElement(
      'svg',
      props,
      _react2['default'].createElement('path', {
        d: 'M21 14.25V18c0 .497-.21.974-.586 1.326a2.07 2.07 0 0 1-1.414.549H5a2.07 2.07 0 0 1-1.414-.55A1.817 1.817 0 0 1 3 18v-3.75M7 9.563l5 4.687 5-4.688M12 14.25V3',
        stroke: '#A8A4B9',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      })
    );
  }

  return DownloadIcon;
}();

DownloadIcon.defaultProps = {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
};

var PlayIcon = function () {
  function PlayIcon(props) {
    return _react2['default'].createElement(
      'svg',
      props,
      _react2['default'].createElement('path', {
        d: 'M5.417 2.5L17.083 10 5.417 17.5v-15z',
        stroke: '#A8A4B9',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      })
    );
  }

  return PlayIcon;
}();

PlayIcon.defaultProps = {
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
};


var defaultFormatTime = function defaultFormatTime(_) {
  return _;
};
var hourBySeconds = 3600;

var OnlinepbxPlayer = function (_React$Component) {
  _inherits(OnlinepbxPlayer, _React$Component);

  function OnlinepbxPlayer(props) {
    _classCallCheck(this, OnlinepbxPlayer);

    var _this = _possibleConstructorReturn(this, (OnlinepbxPlayer.__proto__ || Object.getPrototypeOf(OnlinepbxPlayer)).call(this, props));

    _this.state = {
      volume: 50,
      playStatus: props.playStatus || 'STOPPED',
      position: 0,
      duration: 1
    };
    return _this;
  }

  _createClass(OnlinepbxPlayer, [{
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate(prevProps) {
        if (this.props.playStatus && prevProps.playStatus !== this.props.playStatus && this.props.playStatus !== this.state.playStatus) {
          this.setState({ playStatus: this.props.playStatus });
          if (this.props.playStatus === 'PLAYING') {
            this.audio.play();
          }
          if (this.props.playStatus === 'PAUSED') {
            this.audio.pause();
          }
          if (this.props.playStatus === 'STOPPED') {
            this.audio.pause();
            this.audio.currentTime = 0;
          }
        }

        if (this.state.position === this.state.duration) {
          this.props.setPlayStatus('STOPPED');
        }
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'shouldComponentUpdate',
    value: function () {
      function shouldComponentUpdate(nextProps, nextState) {
        return this.state.playStatus !== nextState.playStatus || this.props.url !== nextProps.url || this.state.position !== nextState.position || this.state.duration !== nextState.duration;
      }

      return shouldComponentUpdate;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        var _state = this.state,
            position = _state.position,
            duration = _state.duration,
            volume = _state.volume,
            playStatus = _state.playStatus;
        var _props = this.props,
            _props$formatTime = _props.formatTime,
            formatTime = _props$formatTime === undefined ? customFormatTime : _props$formatTime,
            url = _props.url,
            isDownload = _props.isDownload,
            _props$setPlayStatus = _props.setPlayStatus,
            setPlayStatus = _props$setPlayStatus === undefined ? defaultFormatTime : _props$setPlayStatus,
            onClose = _props.onClose,
            onDownload = _props.onDownload;

        var positionHalfSeconds = Math.round(position / 1);
        var durationHalfSeconds = Math.round(duration / 1);
        return _react2['default'].createElement(
          'div',
          { className: 'onlinepbx__lib__player__mini' },
          _react2['default'].createElement('audio', {
            ref: function () {
              function ref(node) {
                return _this2.audio = node;
              }

              return ref;
            }() // eslint-disable-line no-return-assign
            , preload: 'metadata',
            src: url,
            volume: volume * 0.01,
            autoPlay: playStatus === 'PLAYING',
            onDurationChange: function () {
              function onDurationChange(evt) {
                _this2.audio.playbackRate = 1;
                _this2.setState({ duration: evt.target.duration });
              }

              return onDurationChange;
            }(),
            onTimeUpdate: function () {
              function onTimeUpdate(evt) {
                return _this2.setState({ position: evt.target.currentTime });
              }

              return onTimeUpdate;
            }()
          }),
          _react2['default'].createElement(
            'div',
            { className: 'onlinepbx__lib__player__mini__timer' },
            String(formatTime(position, duration >= hourBySeconds)) + '/' + String(formatTime(duration, duration >= hourBySeconds))
          ),
          _react2['default'].createElement(_progress2['default'], {
            min: 0,
            max: durationHalfSeconds,
            position: positionHalfSeconds,
            onChange: function () {
              function onChange(newPosition) {
                _this2.audio.currentTime = newPosition * 1;
              }

              return onChange;
            }()
          }),
          _react2['default'].createElement(
            'div',
            { className: 'onlinepbx__lib__player__mini__buttons' },
            playStatus === 'PLAYING' ? _react2['default'].createElement(
              'button',
              {
                className: 'onlinepbx__lib__player__mini__button',
                title: '\u041F\u0430\u0443\u0437\u0430',
                onClick: function () {
                  function onClick() {
                    _this2.audio.pause();
                    setPlayStatus('PAUSED');
                    _this2.setState({ playStatus: 'PAUSED' });
                  }

                  return onClick;
                }()
              },
              _react2['default'].createElement(PauseIcon, { className: 'onlinepbx__lib__player__mini__button__pause' })
            ) : _react2['default'].createElement(
              'button',
              {
                className: 'onlinepbx__lib__player__mini__button',
                title: '\u0412\u043E\u0441\u043F\u0440\u043E\u0438\u0437\u0432\u0435\u0441\u0442\u0438',
                onClick: function () {
                  function onClick() {
                    _this2.audio.play();
                    setPlayStatus('PLAYING');
                    _this2.setState({ playStatus: 'PLAYING' });
                  }

                  return onClick;
                }()
              },
              _react2['default'].createElement(PlayIcon, { className: 'onlinepbx__lib__player__mini__button__play' })
            ),
            isDownload && _react2['default'].createElement(
              'a',
              { title: '\u0421\u043A\u0430\u0447\u0430\u0442\u044C', className: 'onlinepbx__lib__player__mini__button', onClick: onDownload
                // download={'rec.mp3'} href={url}
                // target='_blank' rel='noreferrer noopener'
              },
              _react2['default'].createElement(DownloadIcon, { className: 'onlinepbx__lib__player__mini__button__download' })
            ),
            _react2['default'].createElement(
              'button',
              { title: '\u0417\u0430\u043A\u0440\u044B\u0442\u044C \u043F\u043B\u0435\u0435\u0440', className: 'onlinepbx__lib__player__mini__button', onClick: onClose },
              _react2['default'].createElement(CrossIcon, { className: 'onlinepbx__lib__player__mini__button__cross' })
            )
          )
        );
      }

      return render;
    }()
  }]);

  return OnlinepbxPlayer;
}(_react2['default'].Component);

exports['default'] = OnlinepbxPlayer;


function customFormatTime(timestamp) {
  var minutes = ('0' + String(Math.floor(timestamp / 60) || 0)).substr(-2);
  var seconds = ('0' + String(Math.floor(timestamp - minutes * 60) || 0)).substr(-2);

  return String(minutes) + ':' + String(seconds);
}